module.exports = __webpack_public_path__ + "img/symbol_3.5d425972.png";